import React from "react";
import Lottie from "react-lottie";
// import * as loaderSbm from "../../../assets/lottieAnimationsData/data.json";
import loader from "./Loader.json";

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: loader,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

const Loader = (size: any) => {
  return (
    <div
      // className="absolute inset-0 flex items-center justify-center"
      // style={{ backgroundColor: "rgba(0, 0, 0, 0.5)", backdropFilter: "blur(5px)" }}
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }}
    >
      <div className="relative" style={{ zIndex: 1 }}>
        <Lottie options={defaultOptions} height={size || 150} width={size || 150} />
      </div>
    </div>
  );
};

export default Loader;
